var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeeptruckinLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 33,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.201 32.215h50.414c0-16.014-.104-32.028-.104-32.028H2.167c-.748 0-1.378.63-1.471 1.47C.27 5.474-.647 16.398.727 30.714c.082.854.716 1.502 1.474 1.502",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.677 18.105l-.77 1.599v5.37h-2.49V7.59h2.49v7.618l3.26-7.618h2.49l-3.463 7.793 3.463 9.69h-2.558zm10.657-3.147h3.418v2.498h-3.418v5.12h4.3v2.497h-6.79V7.59h6.79v2.498h-4.3zm10.161 0h3.418v2.498h-3.418v5.12h4.3v2.497h-6.79V7.59h6.79v2.498h-4.3zm10.161-4.87v5.919h1.177c.793 0 1.223-.375 1.223-1.648v-2.623c0-1.274-.43-1.648-1.223-1.648h-1.177zm1.177-2.498c2.513 0 3.713 1.498 3.713 4.321v2.273c0 2.822-1.2 4.32-3.713 4.32h-1.177v6.57h-2.49V7.59h3.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A88C2",
    d: "M53.656 32.215H73.52V.187H53.656z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M59.754 7.59h7.668v2.498H64.83v14.985h-2.481V10.088h-2.594z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A88C2",
    d: "M74.776 32.215H94.64V.187H74.776z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.558 10.087v5.37h.97c.924 0 1.488-.45 1.488-1.848v-1.723c0-1.274-.383-1.799-1.263-1.799h-1.195zm2.706 14.986c-.022-.125-.067-.224-.09-.324-.068-.2-.113-.475-.113-.95-.022-.224-.022-.524-.022-.874v-2.747c0-1.623-.474-2.223-1.624-2.223h-.857v7.118h-2.481V7.59h3.744c2.594 0 3.676 1.324 3.676 4.021v1.374c0 1.798-.541 2.972-1.624 3.546 1.263.575 1.647 1.898 1.647 3.722v2.697c0 .875.022 1.449.27 2.123h-2.526z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A88C2",
    d: "M95.886 32.32h19.863V.292H95.886z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.6 7.696v13.487c0 1.274.496 1.698 1.285 1.698.79 0 1.286-.424 1.286-1.698V7.696h2.345v13.312c0 2.822-1.263 4.396-3.699 4.396s-3.699-1.574-3.699-4.396V7.696h2.481z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A88C2",
    d: "M116.995 32.32h19.863V.292h-19.863z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.67 18.66v2.323c0 2.822-1.262 4.396-3.698 4.396s-3.7-1.574-3.7-4.396v-9.091c0-2.823 1.264-4.396 3.7-4.396s3.699 1.573 3.699 4.396v1.698h-2.346v-1.873c0-1.274-.496-1.724-1.286-1.724-.789 0-1.285.45-1.285 1.724v9.44c0 1.275.496 1.7 1.285 1.7.79 0 1.286-.425 1.286-1.7V18.66h2.346z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A88C2",
    d: "M138.062 32.269h19.863V.241h-19.863z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M147.475 18.16l-.767 1.598v5.37h-2.48V7.644h2.48v7.618l3.248-7.618h2.481l-3.45 7.793 3.45 9.69h-2.548z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A88C2",
    d: "M159.088 32.32h19.863V.292h-19.863z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M167.78 25.179h2.48V7.695h-2.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.305 32.215h-18.207c-.098-16.014 0-32.028 0-32.028h18.247c.85 0 1.566.63 1.672 1.47.483 3.816 1.526 14.74-.035 29.056a1.685 1.685 0 01-1.677 1.502",
    fill: "#4A88C2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M188.11 12.41v12.663h-2.233V7.59h3.112l2.549 10.465V7.59h2.21v17.483H191.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeeptruckinLogo);
export default __webpack_public_path__ + "static/media/keeptruckin-logo.98bc0dce0948a0f14ed5caf809cc944b.svg";
export { ForwardRef as ReactComponent };